import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import useCopyText from 'hooks/useCopyText'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import styles from './FTPDetailsDialog.module.scss'

const FTPDetailsDialog = ({ onClose, username, password }) => {
  const copy = useCopyText()
  return (
    <>
      <ConfirmationDialog
        title="FTP credentials"
        theme="blacklist"
        onClose={onClose}
        maxWidth={800}
        hasConfirmButton={false}
        hasCloseButton={true}
        negativeMessage={'Close'}
      >
        {!username || !password ? (
          <div className={styles.container}>
            <p className={styles.ftpTitle}>The user does not have FTP credentials</p>
          </div>
        ) : (
          <div className={styles.container}>
            <div className={styles.serverInfo}>
              <div className={styles.dataRow}>
                <p className={styles.ftpTitle}>FTP server</p>
                <span className={styles.ftpText}>ai-sftp.directful.com</span>
              </div>
              <div className={styles.dataRow}>
                <p className={styles.ftpTitle}>Port</p>
                <span className={styles.ftpText}>22</span>
              </div>
            </div>
            <div className={styles.dataRow}>
              <p className={styles.ftpTitle}>Username</p>
              <span className={styles.ftpText}>{username}</span>
            </div>
            <div className={styles.dataRow}>
              <p className={styles.ftpTitle}>Password</p>
              <span className={styles.ftpText}>*******</span>
              <button
                className={styles.ftpPasswordCopyButton}
                onClick={() => password && copy(password)}
              >
                <CopyIcon />
              </button>
            </div>
          </div>
        )}
      </ConfirmationDialog>
    </>
  )
}

export default FTPDetailsDialog
